import { Translation } from "i18n/config";
import { HelpTranslation, HowToSignAnAgreementPost } from "./typing";

const HowToSignAnAgreementPostTexts: Translation<HowToSignAnAgreementPost> = {
	es: {
		title: "Cómo firmar convenio con Vinglet?",
		intro: `
			Firmar convenio con Vinglet te dara muchas oportunidades dentro de la plataforma,
			ya sea que eres una Universidad, Institucion, Empresa, Aceleredora, Start-up, Incubadora,
			Business Angel, seguramente te interese crear lazos con otros perfiles juridicos, 
			ya sea de tu sector o de otro, y generar alianzas, sinergia o hasta retos en conjunto.
		`,
		steps: [
			{
				description:
					"Para comenzar, deberas de poseer una cuenta dentro de Vinglet, es totalmente gratuito y puedes hacerlo accediendo al siguiente link.",
				link: "/signup",
				linkText: "Registrarse",
			},
			{
				description:
					"Luego deberas identificar que tipo de Perfil Juridico eres, ya sea Universidad, Empresa entre otros.",
				link: "/business-profile/new",
				linkText: "Crear Perfil Juridico",
			},
			{
				description:
					"Por último, deberás enviar un email a la siguiente casilla, especificando el nombre del Perfil Jurídico ya creado y luego, nos pondremos en contacto para concretar el convenio.",
				link: "mailto:info@vinglet.com",
				linkText: "info@vinglet.com",
			},
		],
	},
	en: {
		title: "How to sign an agreement with Vinglet?",
		intro: `
			Signing an agreement with Vinglet will give you many opportunities within the platform,
			whether you are a University, Institution, Company, Accelerator, Start-up, Incubator,
			Business Angel, surely you are interested in creating ties with other legal profiles,
			either from your sector or from another, and generate alliances, synergy or even joint challenges.
		`,
		steps: [
			{
				description:
					"To start, you must have an account within Vinglet, it is completely free and you can do it by accessing the following link.",
				link: "/signup",
				linkText: "Sign up",
			},
			{
				description:
					"Then you must identify what type of Legal Profile you are, be it University, Company, among others.",
				link: "/business-profile/new",
				linkText: "Create Legal Profile",
			},
			{
				description:
					"Finally, you must send an email to the following box, specifying the name of the Legal Profile already created and then, we will contact you to finalize the agreement.",
				link: "mailto:info@vinglet.com",
				linkText: "info@vinglet.com",
			},
		],
	},
	ca: {
		title: "Cómo firmar convenio con Vinglet?",
		intro: `
			Firmar convenio con Vinglet te dara muchas oportunidades dentro de la plataforma,
			ya sea que eres una Universidad, Institucion, Empresa, Aceleredora, Start-up, Incubadora,
			Business Angel, seguramente te interese crear lazos con otros perfiles juridicos, 
			ya sea de tu sector o de otro, y generar alianzas, sinergia o hasta retos en conjunto.
		`,
		steps: [
			{
				description:
					"Para comenzar, deberas de poseer una cuenta dentro de Vinglet, es totalmente gratuito y puedes hacerlo accediendo al siguiente link.",
				link: "/signup",
				linkText: "Registrarse",
			},
			{
				description:
					"Luego deberas identificar que tipo de Perfil Juridico eres, ya sea Universidad, Empresa entre otros.",
				link: "/business-profile/new",
				linkText: "Crear Perfil Juridico",
			},
			{
				description:
					"Por último, deberás enviar un email a la siguiente casilla, especificando el nombre del Perfil Jurídico ya creado y luego, nos pondremos en contacto para concretar el convenio.",
				link: "mailto:info@vinglet.com",
				linkText: "info@vinglet.com",
			},
		],
	},
	pt: {
		title: "Como assinar um acordo com a Vinglet?",
		intro: `
			Assinar um acordo com a Vinglet lhe dará muitas oportunidades dentro da plataforma,
			seja você Universidade, Instituição, Empresa, Aceleradora, Start-up, Incubadora,
			Business Angel, certamente você está interessado em criar vínculos com outros perfis jurídicos,
			seja do seu setor ou de outro, e gere alianças, sinergias ou mesmo desafios conjuntos.
		`,
		steps: [
			{
				description:
					"Para começar, você deve ter uma conta no Vinglet, é totalmente gratuito e você pode fazer isso acessando o link a seguir.",
				link: "/signup",
				linkText: "Registe-se",
			},
			{
				description:
					"Então você deve identificar que tipo de Perfil Jurídico você é, seja Universidade, Empresa, entre outros.",
				link: "/business-profile/new",
				linkText: "Criar perfil jurídico",
			},
			{
				description:
					"Por fim, você deve enviar um e-mail para a caixa a seguir, especificando o nome do Perfil Jurídico já criado e, em seguida, entraremos em contato para finalizar o acordo.",
				link: "mailto:info@vinglet.com",
				linkText: "info@vinglet.com",
			},
		],
	},
};

export const HelpTexts: Translation<HelpTranslation> = {
	es: {
		title: "Ayuda",
		description:
			"Si has tenido algun inconveniente dentro de la plataforma relacionado al funcionamiento de esta plataforma, por favor tenga en cuenta chequear el siguiente formulario y comunicar acerca del problema asi nuestro equipo tecnico pueda hecharle un vistazo.",
		goToTheForm: "Ir al Formulario",
		howToSignAnAgreement: HowToSignAnAgreementPostTexts.es,
	},
	en: {
		title: "Help",
		description: `If you have had any issue related to the performance of this platform,
					please check the following form and then explain what is going on in
					order that we could take a look.`,
		goToTheForm: "Go to the Form",
		howToSignAnAgreement: HowToSignAnAgreementPostTexts.en,
	},
	ca: {
		title: "Ayuda",
		description:
			"Si has tenido algun inconveniente dentro de la plataforma relacionado al funcionamiento de esta plataforma, por favor tenga en cuenta chequear el siguiente formulario y comunicar acerca del problema asi nuestro equipo tecnico pueda hecharle un vistazo.",
		goToTheForm: "Ir al Formulario",
		howToSignAnAgreement: HowToSignAnAgreementPostTexts.cat,
	},
	pt: {
		title: "Ajuda",
		description:
			"Se você teve algum problema dentro da plataforma relacionado ao funcionamento desta plataforma, lembre-se de verificar o formulário a seguir e comunicar o problema para que nossa equipe técnica possa dar uma olhada.",
		goToTheForm: "Ir para o formulário",
		howToSignAnAgreement: HowToSignAnAgreementPostTexts.es,
	},
};
